import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Adjust the path based on your project structure
import { useNavigate } from 'react-router-dom';

const AddPriceList = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        description: '',
        price_category: '',
        effective_from: '',
        sno: '',
        item_code: '',
        barcode: '',
        item_name: '',
        item_type: '',
        rate: '',
        dealer_rate: '',
        wholesale_rate: '',
        mrp: '',
        discount: '',
    });

    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);

        fetch(`${BASE_URL}pricelists`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Price List added successfully!');
                    navigate('/PriceList'); // Redirect to the PriceLists page
                } else {
                    setError('Failed to add Price List. Please try again.');
                }
            })
            .catch(() => setError('An error occurred while adding the Price List.'));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Add Price List</h3>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="description" className="form-label">
                                        Description
                                    </label>
                                    <input
                                        type="text"
                                        id="description"
                                        name="description"
                                        className="form-control"
                                        value={formData.description}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="price_category" className="form-label">
                                        Price Category
                                    </label>
                                    <input
                                        type="text"
                                        id="price_category"
                                        name="price_category"
                                        className="form-control"
                                        value={formData.price_category}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="effective_from" className="form-label">
                                        Effective From
                                    </label>
                                    <input
                                        type="datetime-local"
                                        id="effective_from"
                                        name="effective_from"
                                        className="form-control"
                                        value={formData.effective_from}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="sno" className="form-label">
                                        S. No.
                                    </label>
                                    <input
                                        type="number"
                                        id="sno"
                                        name="sno"
                                        className="form-control"
                                        value={formData.sno}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="item_code" className="form-label">
                                        Item Code
                                    </label>
                                    <input
                                        type="text"
                                        id="item_code"
                                        name="item_code"
                                        className="form-control"
                                        value={formData.item_code}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="barcode" className="form-label">
                                        Barcode
                                    </label>
                                    <input
                                        type="text"
                                        id="barcode"
                                        name="barcode"
                                        className="form-control"
                                        value={formData.barcode}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="item_name" className="form-label">
                                        Item Name
                                    </label>
                                    <input
                                        type="text"
                                        id="item_name"
                                        name="item_name"
                                        className="form-control"
                                        value={formData.item_name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="item_type" className="form-label">
                                        Item Type
                                    </label>
                                    <input
                                        type="text"
                                        id="item_type"
                                        name="item_type"
                                        className="form-control"
                                        value={formData.item_type}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="rate" className="form-label">
                                        Rate
                                    </label>
                                    <input
                                        type="text"
                                        id="rate"
                                        name="rate"
                                        className="form-control"
                                        value={formData.rate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="dealer_rate" className="form-label">
                                        Dealer Rate
                                    </label>
                                    <input
                                        type="text"
                                        id="dealer_rate"
                                        name="dealer_rate"
                                        className="form-control"
                                        value={formData.dealer_rate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="wholesale_rate" className="form-label">
                                        Wholesale Rate
                                    </label>
                                    <input
                                        type="text"
                                        id="wholesale_rate"
                                        name="wholesale_rate"
                                        className="form-control"
                                        value={formData.wholesale_rate}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="mrp" className="form-label">
                                        MRP
                                    </label>
                                    <input
                                        type="text"
                                        id="mrp"
                                        name="mrp"
                                        className="form-control"
                                        value={formData.mrp}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="discount" className="form-label">
                                        Discount
                                    </label>
                                    <input
                                        type="text"
                                        id="discount"
                                        name="discount"
                                        className="form-control"
                                        value={formData.discount}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </div>
                            {error && <p className="text-danger">{error}</p>}
                            <button type="submit" className="btn btn-primary">
                                Add Price List
                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddPriceList;
